import { getInboundSMSMessages } from 'api/InboundSmsAPI';
import { AxiosError } from 'axios';
import { addNegativeToast } from 'modules/toastContainer';
import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { getErrorResponse } from 'utils/xhr';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import type { InboundSMS } from './types';

/**
 * fetchInboundSMSMessages
 * Saga for fetching recent inbound SMS messages
 * @return { void }
 */
export function* fetchInboundSMSMessages() {
  try {
    const response: { data: InboundSMS[] } = yield call(getInboundSMSMessages);
    yield put(actions.fetchInboundSMSResponse(response.data));
  } catch (error) {
    const errorMessage =
      error instanceof AxiosError && error.code === 'ERR_BAD_RESPONSE'
        ? error.message
        : getErrorResponse(error);

    yield put(actions.fetchInboundSMSError(errorMessage));
    const toastMessage = `Error fetching inbound SMS messages. ${errorMessage}`;
    yield put(addNegativeToast(toastMessage));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_INBOUND_SMS_REQUEST, fetchInboundSMSMessages)]);
